import * as PIXI from 'pixi.js';
import * as _ from 'lodash';

import GameManager from '@/assets/js/game/GameManager';
import MapArea from '@/assets/js/game/MapArea';

import AreaData from '@/assets/data/area';

const GRASS_HEIGHT = 10;
const GRASS_COLOR = 0x8aa400;
const FIELD_HEIGHT = 110;
const FIELD_COLOR = 0xadce26;

let mapAreas, container, fieldContainer, field, grass;

export default class Map {
  static init(stage) {
    fieldContainer = new PIXI.Container();
    container = new PIXI.Container();
    Map._setField();
    stage.addChild(fieldContainer);

    this.reset();
    stage.addChild(container);
  }

  static reset() {
    container.x = 0;
    container.removeChildren();
    Map._setArea();
  }

  static onResize() {
    for (let i = 0; i < mapAreas.length; i++) {
      mapAreas[i].onResize();
    }
  }

  static update(delta) {
    if (!GameManager.isStart || GameManager.isGoal) return;

    container.x -= GameManager.runSpeed;

    for (let i = 0; i < mapAreas.length; i++) {
      const mapArea = mapAreas[i];
      mapArea.update(delta, container.x);
    }

    if (Map._isGoal) {
      GameManager.goal();
      container.x = -Map._containerWidth;
    }
  }

  static _setField() {
    if (field) fieldContainer.removeChild(field);
    if (grass) fieldContainer.removeChild(grass);

    const width = GameManager.calcRatio(GameManager.gameWidth);
    const height = GameManager.calcRatio(GameManager.gameHeight);
    const fieldHeight = GameManager.calcRatio(FIELD_HEIGHT);
    field = new PIXI.Graphics();
    field.x = 0;
    field.y = height - fieldHeight;
    field
      .beginFill(FIELD_COLOR)
      .drawRect(0, 0, width, fieldHeight + 2)
      .endFill();

    const grassHeight = GameManager.calcRatio(GRASS_HEIGHT);
    grass = new PIXI.Graphics();
    grass.x = 0;
    grass.y = field.y - grassHeight;
    grass
      .beginFill(GRASS_COLOR)
      .drawRect(0, 0, width, grassHeight)
      .endFill();

    fieldContainer.addChild(field);
    fieldContainer.addChild(grass);
  }

  static _setArea() {
    mapAreas = [];

    const levelData = _.filter(AreaData, { level: GameManager.level });
    for (let i = 0; i < GameManager.mapAreaLength; i++) {
      const mapArea = new MapArea(levelData, i + 1);
      mapAreas.push(mapArea);
      container.addChild(mapArea.container);
    }
  }

  static get _containerWidth() {
    const width = GameManager.calcRatio(GameManager.gameWidth);
    return width * 2 * GameManager.mapAreaLength;
  }

  static get _isGoal() {
    return -Map._containerWidth >= container.x;
  }

  static debugFinish() {
    container.x =
      -GameManager.calcRatio(GameManager.gameWidth * 2) *
      GameManager.mapAreaLength;
  }
}
